/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliveryResult } from './DeliveryResult';
import {
    DeliveryResultFromJSON,
    DeliveryResultFromJSONTyped,
    DeliveryResultToJSON,
    DeliveryResultToJSONTyped,
} from './DeliveryResult';

/**
 * Response from notification orchestration
 * @export
 * @interface NotifyResponse
 */
export interface NotifyResponse {
    /**
     * Whether any notifications were sent
     * @type {boolean}
     * @memberof NotifyResponse
     */
    success?: boolean;
    /**
     * Number of delivery targets attempted
     * @type {number}
     * @memberof NotifyResponse
     */
    attemptedCount?: number;
    /**
     * Number of successful deliveries
     * @type {number}
     * @memberof NotifyResponse
     */
    successCount?: number;
    /**
     * Per-recipient delivery results
     * @type {Array<DeliveryResult>}
     * @memberof NotifyResponse
     */
    results?: Array<DeliveryResult>;
    /**
     * Error message if orchestration failed entirely
     * @type {string}
     * @memberof NotifyResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the NotifyResponse interface.
 */
export function instanceOfNotifyResponse(value: object): value is NotifyResponse {
    return true;
}

export function NotifyResponseFromJSON(json: any): NotifyResponse {
    return NotifyResponseFromJSONTyped(json, false);
}

export function NotifyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotifyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'attemptedCount': json['attemptedCount'] == null ? undefined : json['attemptedCount'],
        'successCount': json['successCount'] == null ? undefined : json['successCount'],
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(DeliveryResultFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function NotifyResponseToJSON(json: any): NotifyResponse {
    return NotifyResponseToJSONTyped(json, false);
}

export function NotifyResponseToJSONTyped(value?: NotifyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'attemptedCount': value['attemptedCount'],
        'successCount': value['successCount'],
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(DeliveryResultToJSON)),
        'error': value['error'],
    };
}

